import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingCard = ({ 
  name, 
  price, 
  period = '', 
  description, 
  features, 
  popular = false,
  ctaText = "Get Started",
  ctaLink = "/contact",
  onCtaClick = null
}) => {
  return (
    <div className={`relative rounded-xl h-full flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
      popular 
        ? 'bg-primary text-white border-2 border-primary' 
        : 'bg-white border border-gray-200 hover:border-lime/40'
    }`} data-testid={`pricing-card-${name.toLowerCase()}`}>
      {popular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <span className="bg-lime text-white text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full">Most Popular</span>
        </div>
      )}
      
      <div className="p-8 flex-grow flex flex-col">
        <div className="mb-6">
          <h3 className={`font-heading text-lg font-bold mb-1 ${popular ? 'text-white' : 'text-primary'}`}>{name}</h3>
          {description && (
            <p className={`text-sm ${popular ? 'text-gray-400' : 'text-gray-500'}`}>{description}</p>
          )}
        </div>
        
        <div className="mb-6">
          <div className="flex items-baseline gap-1">
            <span className={`font-heading text-4xl font-extrabold tracking-tighter ${popular ? 'text-lime' : 'text-primary'}`}>
              {price}
            </span>
            {period && <span className={`text-sm ${popular ? 'text-gray-400' : 'text-gray-500'}`}>{period}</span>}
          </div>
        </div>
        
        <ul className="space-y-3 mb-8 flex-grow max-h-64 overflow-y-auto pr-1 pricing-scroll">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <Check className={`h-4 w-4 mt-0.5 shrink-0 ${popular ? 'text-lime' : 'text-lime'}`} />
              <span className={`text-sm leading-relaxed ${popular ? 'text-gray-300' : 'text-gray-600'}`}>{feature}</span>
            </li>
          ))}
        </ul>
        
        {onCtaClick ? (
          <button
            onClick={onCtaClick}
            data-testid={`pricing-cta-${name.toLowerCase()}`}
            className={`block w-full text-center py-2.5 px-5 rounded-xl font-bold text-sm transition-all duration-300 active:scale-95 ${
              popular
                ? 'bg-lime text-white hover:bg-lime-light font-bold'
                : 'bg-[#2d2d51] text-white hover:bg-[#2d2d51]/90'
            }`}
          >
            {ctaText}
          </button>
        ) : (
          <Link
            to={ctaLink}
            className={`block w-full text-center py-2.5 px-5 rounded-xl font-bold text-sm transition-all duration-300 ${
              popular
                ? 'bg-lime text-[#2d2d51] hover:bg-lime-light'
                : 'bg-[#2d2d51] text-white hover:bg-[#2d2d51]/90'
            }`}
          >
            {ctaText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default PricingCard;
